<template>
  <loading v-if="loading" />
  <table class="c-data-table" v-else-if="versions && versions.length > 0">
    <tr v-for="(version, index) in versions" :key="index">
      <td width="50%">
        {{ version.title }}
      </td>
      <td width="20%" class="u-ta-center">{{ version.version }}</td>
      <td width="20%" class="u-ta-center">
        <base-datetime :date="version.created_time"></base-datetime>
      </td>
      <form-actions
        class="u-ta-center u-padding-0"
        :rowData="version"
      ></form-actions>
    </tr>
  </table>

  <table v-else>
    <tr>
      <td width="100%">
        <span>No versions found</span>
      </td>
    </tr>
  </table>
</template>

<script>
import FormActions from "@/components/FormActions.vue";

export default {
  name: "form-detail-row",

  components: {
    FormActions,
  },

  data() {
    return {
      loading: true
    }
  },

  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
    options: {
      type: Object,
    },
  },

  async created() {
    await this.$store.dispatch("Forms/listVersions", this.rowData.id);
    this.loading = false;
  },

  computed: {
    versions() {
      const versions = this.$store.state.Forms.formVersions[this.rowData.id];
      if (versions) {
        return versions
          .filter(
            (vers) => vers.version !== this.rowData.current_version.version
          )
          .sort((a, b) => a.id - b.id);
      }
    },
  },

  methods: {
    onClickTableRow(version) {
      this.$router.push({
        name: "AdminFormVersionPreview",
        params: {
          id: this.rowData.id,
          versionId: version.id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
tr.vuetable-detail-row {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
  background: $colour-nhs-white;

  tr:last-of-type {
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.11);
  }

  > td {
    padding: 0;
  }
}

@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  tr.vuetable-detail-row tr {
    background: tint($colour-nhs-pale-grey, 40);
  }
}
</style>
